<template>
  <div>
    <el-card class="box-card">
      <div>
        <h2 class="text-center student_name">{{ student.studentName }}</h2>
        <table class="c-talbe">
          <tr>
            <td class="text-right" width="150">登录手机号</td>
            <td>{{ student.loginPhone }}</td>
          </tr>
        </table>
        <p class="title">基本信息</p>
        <table class=" c-talbe">
          <tr>
            <td class="text-right" width="150">学号</td>
            <td>{{ student.studentNo }}</td>
          </tr>
          <tr>
            <td class="text-right">性别</td>
            <td>{{ student.studentGendar }}</td>
          </tr>
          <tr>
            <td class="text-right">学院</td>
            <td>{{ student.studentCollege }}</td>
          </tr>
          <tr>
            <td class="text-right">专业</td>
            <td>{{ student.studentMajor }}</td>
          </tr>
          <tr>
            <td class="text-right">入学年份</td>
            <td>{{ student.studentGrade }}</td>
          </tr>
          <tr>
            <td class="text-right">学历</td>
            <td>{{ student.studentDegree }}</td>
          </tr>
        </table>
        <p class="title">其他信息</p>
        <table class="c-talbe">
          <tr>
            <td class="text-right" width="150">出生年份</td>
            <td>{{ student.studentBirtYear }}</td>
          </tr>
          <tr>
            <td class="text-right">生源地</td>
            <td>{{ student.studentHome }}</td>
          </tr>
        </table>
      </div>
    </el-card>
    <div class="text-center mt10">
      <el-button class="button" style="margin-left: 0" @click.native.prevent="changLink('/modifyPersonalData')">
        <p>修改资料</p>
        <i class="el-icon-arrow-right"/>
      </el-button>
      <el-button class="button" style="margin-left: 0" @click="changLink('/message')">
        <p>
          消息中心
          <el-badge v-if="messageNum !== 0" :value=messageNum :max="99" class="item"/>
        </p>
        <i class="el-icon-arrow-right"/>
      </el-button>
      <el-button class="button" style="margin-left: 0" @click="logout">
        <p>退出登录</p>
        <i class="el-icon-arrow-right"/>
      </el-button>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getSessionData} from '@/utils/cache'
import HttpRequest from "../utils/request";

export default {
  name: "mainpage",
  data() {
    return {
      messageNum: 0,
    };
  },
  computed: {
    ...mapState({
      student: state => state.user.student,
      admin: state => state.user.admin
    }),
  },
  created() {
    this.getMessageNum()
  },
  mounted() {
    document.title = '个人资料'
  },
  methods: {
    changLink(link) {
      this.$router.push(link);
    },
    logout() {
      store.dispatch("setLoginStatus", 0);
      let openOtherHomepage = this.admin.jsonSetting.open_homepage === "" ? "" : "&openOtherHomepage=1"
      this.$router.push("login?partner=" + getSessionData("partner") + openOtherHomepage)
    },
    getMessageNum() {
      let url1 = "/constub/getSmsUnreadNum";
      let data1 = {token: this.student.token};
      HttpRequest.requestFormPost(url1, data1).then((res) => {
        if (res && res.result.success) {
          this.messageNum = res.data;
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    }
  }
};
</script>


<style scoped>
.title {
  width: 100%;
  padding: 10px;
  background-color: #D2D9F1FF;
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}

.c-talbe {
  display: table-cell;
  width: 100%;
}

>>> .box-card .el-card__body, .el-main {
  padding: 40px 20px
}

.c-talbe td {
  padding: 5px;
}

.button {
  font-weight: bold;
  width: 100%;
  background: none;
  border: none;
  border-bottom: solid 2px #FFF
}

.button p {
  float: left;
}

.button i {
  float: right;
}

.student_name {
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 15px;
}

.student_loginPhone {
  margin: 20px 0;
  font-weight: bold;
}

.el-form--label-top >>> .el-form-item__label {
  padding: 0;
  line-height: 18px
}

tr td:nth-child(2) {
  font-weight: bold;
}
</style>
